import { render, staticRenderFns } from "./AddUsersBtn.vue?vue&type=template&id=58558f06&scoped=true"
import script from "./AddUsersBtn.vue?vue&type=script&lang=js"
export * from "./AddUsersBtn.vue?vue&type=script&lang=js"
import style0 from "./AddUsersBtn.vue?vue&type=style&index=0&id=58558f06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58558f06",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
